




import { defineComponent } from '@vue/composition-api';

import PageColumnWithComponentEditor from '@/components/Component/PageColumnWithComponentEditor.vue';

const New = defineComponent({
  components: {
    PageColumnWithComponentEditor,
  },
  // setup() {},
});

export default New;
